@if (loaded | async) {
  <h2 id="welcomeMessage" class="text-center my-0">
    <span class="avatarName">{{ avatar?.name }}</span>
    <button class="btn btn-xs btn-tertiary mx-2" aria-label="Customize Avatar" (click)="editAvatar()">
      <i class="fa fa-pencil" aria-hidden="true"></i>
    </button>
    @if (hasAudioSupport) {
      <zbp-student-audio-button audioId="landing_avatar"></zbp-student-audio-button>
    }
  </h2>
}
<div id="blobContainer" class="w-75 mx-auto" #blobContainer role="button" aria-label="Play with your blob" (click)="tease()"></div>
<div id="levelContainer" class="d-flex flex-nowrap justify-content-center align-items-baseline">
  <div class="levelContainerStars">
    <img id="levelStarsEarnedImage" src="assets/img/star.png" alt="Stars earned">
    <strong class="starCount px-1">{{ starsEarned }}</strong>
  </div>
  <div class="levelContainerProgressBar w-50 text-center">
    @if (animationPlaying) {
      <i class="fa fa-spin fa-circle-notch" aria-label="Loading" id="animationPlayingIndicator"></i>
    }
    <ngb-progressbar [type]="'success'" [max]="100" [ariaLabel]="'Level ' + avatar?.level.levelNumber + ' - ' + avatar?.level.name + ' progress bar'" [attr.aria-valuetext]="starsEarned + ' of 100 stars earned'" [value]="avatar?.level?.percentageComplete" [height]="'0.65rem'"></ngb-progressbar>
    <div class="py-1">
      <strong>Level {{ avatar?.level.levelNumber }}</strong>
      <span class="levelContainerLevelName"> - {{ avatar?.level.name }}</span>
    </div>
  </div>
</div>
